/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vault_Section_VideoInputs */

const en_vault_section_video = /** @type {(inputs: Vault_Section_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium Video Feed`)
};

const id_vault_section_video = /** @type {(inputs: Vault_Section_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feed Video Premium`)
};

/** @type {(inputs: Vault_Section_VideoInputs) => LocalizedString} */
const es_vault_section_video = en_vault_section_video;

/** @type {(inputs: Vault_Section_VideoInputs) => LocalizedString} */
const fr_vault_section_video = en_vault_section_video;

/** @type {(inputs: Vault_Section_VideoInputs) => LocalizedString} */
const de_vault_section_video = en_vault_section_video;

/** @type {(inputs: Vault_Section_VideoInputs) => LocalizedString} */
const ja_vault_section_video = en_vault_section_video;

/** @type {(inputs: Vault_Section_VideoInputs) => LocalizedString} */
const zh_vault_section_video = en_vault_section_video;

/** @type {(inputs: Vault_Section_VideoInputs) => LocalizedString} */
const ar_vault_section_video = en_vault_section_video;

/** @type {(inputs: Vault_Section_VideoInputs) => LocalizedString} */
const it_vault_section_video = en_vault_section_video;

/** @type {(inputs: Vault_Section_VideoInputs) => LocalizedString} */
const ru_vault_section_video = en_vault_section_video;

/** @type {(inputs: Vault_Section_VideoInputs) => LocalizedString} */
const pt_vault_section_video = en_vault_section_video;

/** @type {(inputs: Vault_Section_VideoInputs) => LocalizedString} */
const ko_vault_section_video = en_vault_section_video;

/**
* | output |
* | --- |
* | "Premium Video Feed" |
*
* @param {Vault_Section_VideoInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const vault_section_video = /** @type {((inputs?: Vault_Section_VideoInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vault_Section_VideoInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vault_section_video(inputs)
	if (locale === "es") return es_vault_section_video(inputs)
	if (locale === "fr") return fr_vault_section_video(inputs)
	if (locale === "de") return de_vault_section_video(inputs)
	if (locale === "ja") return ja_vault_section_video(inputs)
	if (locale === "zh") return zh_vault_section_video(inputs)
	if (locale === "ar") return ar_vault_section_video(inputs)
	if (locale === "id") return id_vault_section_video(inputs)
	if (locale === "it") return it_vault_section_video(inputs)
	if (locale === "ru") return ru_vault_section_video(inputs)
	if (locale === "pt") return pt_vault_section_video(inputs)
	return ko_vault_section_video(inputs)
});